<template>
  <v-text-field
    v-model="displayValue"
    v-bind="commonProps"
    filled
    :rules="[durationFormat]"
    type="text"
    @input="change"
  ></v-text-field>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';

export default {
  mixins: [Input, Editable],
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      displayValue: '00:00:00',
      durationFormat: (value) =>
        /^(?:(?:([0-9]+):)([0-5]?\d):)([0-5]?\d)$/.test(value) || value === '' || 'Must be in format HH:MM:SS',
    };
  },
  mounted() {
    this.displayValue = this.getDuration(this.input);
    this.change();
  },
  methods: {
    change() {
      const dur = this.parseDuration(this.displayValue);
      this.update(dur);
    },
    parseDuration() {
      const split = this.displayValue.split(':');
      return +split[0] * 60 * 60 + +split[1] * 60 + +split[2];
    },
    getDuration(seconds) {
      const toHHMMSS = (secs) => {
        const secNum = parseInt(secs, 10);
        const hours = Math.floor(secNum / 3600);
        const minutes = Math.floor(secNum / 60) % 60;
        const sec = secNum % 60;

        return [hours, minutes, sec].map((v) => (v < 10 ? `0${v}` : v)).join(':');
      };
      return toHHMMSS(seconds);
    },
  },
};
</script>
